module.exports = "::ng-deep mat-card-content .block {\n  display: inline-block; }\n\nform {\n  padding: 10px; }\n"